/*
 * brand.js - Sets the title and colours to use
 */
'use strict';

Sao.config.title = 'alphacentral';
Sao.config.icon_colors = '#16ad80,#777,#d9534f'.split(',');
